(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dex-page-domain-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('dex-domain-grid');
    if (!root) return;

    var input = document.getElementById('dex-domain-search-input');
    var clearBtn = document.getElementById('dex-domain-search-clear');
    var countEl = document.getElementById('dex-domain-count');
    var emptyEl = document.getElementById('dex-domain-empty');
    var azEl = document.getElementById('dex-domain-az');

    var cards = Array.prototype.slice.call(root.querySelectorAll('.dex-domain-card'));
    var sections = Array.prototype.slice.call(root.querySelectorAll('.dex-domain-alpha'));
    var totalCount = cards.length;

    // Build A-Z index
    var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    var presentLetters = new Set();
    sections.forEach(function (s) { presentLetters.add(s.dataset.letter); });

    alphabet.forEach(function (letter) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = letter;
      btn.dataset.letter = letter;
      if (!presentLetters.has(letter)) {
        btn.disabled = true;
      } else {
        btn.addEventListener('click', function () {
          var target = document.getElementById('dex-letter-' + letter);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
      azEl.appendChild(btn);
    });
    var azButtons = Array.prototype.slice.call(azEl.querySelectorAll('button'));

    function updateCount(visibleCount, query) {
      var word = visibleCount === 1 ? 'domain' : 'domains';
      var verb = visibleCount === 1 ? 'matches' : 'match';
      if (query) {
        countEl.innerHTML = '<strong>' + visibleCount + '</strong> ' + word + ' ' + verb + ' "' + escapeHtml(query) + '"';
      } else {
        countEl.innerHTML = '<strong>' + totalCount + ' domains</strong> available';
      }
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    function runFilter() {
      var q = (input.value || '').trim().toLowerCase();
      clearBtn.classList.toggle('is-visible', q.length > 0);

      var visibleCount = 0;
      var visibleLetters = new Set();

      cards.forEach(function (card) {
        var name = (card.dataset.domainName || '').toLowerCase();
        var tag = (card.dataset.domainTagline || '').toLowerCase();
        var matches = !q || name.indexOf(q) !== -1 || tag.indexOf(q) !== -1;
        card.classList.toggle('is-hidden', !matches);
        if (matches) {
          visibleCount++;
          visibleLetters.add(card.closest('.dex-domain-alpha').dataset.letter);
        }
      });

      sections.forEach(function (s) {
        s.classList.toggle('is-hidden', !visibleLetters.has(s.dataset.letter));
      });

      azButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', q.length > 0 && visibleLetters.has(btn.dataset.letter));
      });

      updateCount(visibleCount, q);
      emptyEl.hidden = visibleCount !== 0;
    }

    input.addEventListener('input', runFilter);
    clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      runFilter();
    });

    // Sheet
    var sheet = document.getElementById('dex-domain-sheet');
    var sheetTitle = document.getElementById('dex-domain-sheet-title');
    var sheetBody = document.getElementById('dex-domain-sheet-body');
    var sheetAccent = document.getElementById('dex-domain-sheet-accent');
    var sheetCta = document.getElementById('dex-domain-sheet-cta');
    var lastTrigger = null;

    function openSheet(card) {
      lastTrigger = card;
      sheetTitle.textContent = card.dataset.domainName || '';
      sheetBody.textContent = card.dataset.domainSummary || '';
      sheet.style.setProperty('--sheet-accent', card.dataset.domainAccent || '');
      sheet.style.setProperty('--sheet-cta-bg', card.dataset.domainAnchor || card.dataset.domainAccent || '');
      sheetCta.setAttribute('href', card.dataset.domainUrl || '#');
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { sheetCta.focus(); }, 50);
    }

    function closeSheet() {
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { openSheet(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openSheet(card); }
      });
    });

    sheet.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-close]')) {
        closeSheet();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
